// src/MeuComponente.js
import React, { useEffect, useState } from 'react';
import { SearchBar, Page } from 'components';
import Results from './components/Results';

import Api from 'services/Api';
import Reload from '../../components/Reload/Reload';
import Header from '../../components/Header/Header';
import ApiMServer from 'services/ApiMServer';
import { loadState, saveState } from 'utils/persistState';
import { useAppTheme } from '../../contexts/ThemeContext';

const normalizeSerial = value => {
  if (typeof value === 'string' || typeof value === 'number') {
    return String(value).trim();
  }
  if (value && typeof value === 'object') {
    return String(value.serial || value.serialnumber || value.room || '').trim();
  }
  return '';
};

const hasSupportOrangeRead = user =>
  user?.permission?.supportOrange?.read === true ||
  user?.permission?.remoteaccess?.read === true;

const getSupportOrangePermission = user =>
  user?.permission?.supportOrange ||
  user?.permission?.remoteaccess ||
  { read: false, write: false };

const SuporteOrange = () => {
  const user = JSON.parse(localStorage.getItem('userData'))
  if (!hasSupportOrangeRead(user)) {
    window.location.replace('/home');
  }

  const [filterUnits, setFilterUnits] = useState([]);
  const [allUnits, setAllUnits] = useState([]);
  const [searchData, setSearchData] = useState('');
  const [permission, setPermission] = useState(false);
  const [loading, setLoading] = useState(true);

  const STORAGE_KEY = 'filters:supportorange';

  const currentTheme = useAppTheme();

  // Load persisted filter on mount
  useEffect(() => {
    const persisted = loadState(STORAGE_KEY, null);
    if (persisted && typeof persisted.searchData === 'string') {
      setSearchData(persisted.searchData);
    }
  }, []);

  // Persist filter when it changes
  useEffect(() => {
    saveState(STORAGE_KEY, { searchData });
  }, [searchData]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [{ data: connectedRaw }, { data: serversRaw }] = await Promise.all([
          Api.get('/connection/connected'),
          ApiMServer.get('/api/v1/server-all')
        ]);

        const connectedList = (Array.isArray(connectedRaw) ? connectedRaw : [])
          .map(normalizeSerial)
          .filter(Boolean);

        const oranConnected = new Set(
          connectedList.filter(serial => serial.toUpperCase().includes('ORAN'))
        );

        const servers = Array.isArray(serversRaw) ? serversRaw : [];

        // Filtra no client: o POST /api/v1/server-all com filter em array
        // retorna [] no Motomco atual.
        const onlineServers = servers
          .filter(server => oranConnected.has(server?.serial))
          .sort((a, b) => String(a?.serial || '').localeCompare(String(b?.serial || '')));

        // Serials conectados que não estão no cadastro local ainda
        const knownSerials = new Set(onlineServers.map(s => s.serial));
        const missingOnline = [...oranConnected]
          .filter(serial => !knownSerials.has(serial))
          .sort((a, b) => a.localeCompare(b))
          .map(serial => ({
            serial,
            ip: '',
            company_id: '',
            company: null,
            updatedAt: null
          }));

        const list = [...onlineServers, ...missingOnline];
        setFilterUnits(list);
        setAllUnits(list);
      } catch (error) {
        console.error('Erro ao buscar equipamentos Orange:', error);
        setFilterUnits([]);
        setAllUnits([]);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
    setPermission(getSupportOrangePermission(user));

    const interval = setInterval(() => {
      if (searchData === '') {
        fetchData();
      }
    }, 20000);

    return () => clearInterval(interval);

  }, []);

  const handleSearch = () => {
    if (searchData === '') {
      setAllUnits(filterUnits);
    } else {
      const term = searchData.toLowerCase();
      const equipamentsSearch = filterUnits.filter((item) => (
        (item?.serial?.toLowerCase().includes(term)) ||
        (item?.ip?.toLowerCase().includes(term)) ||
        (item?.company?.name?.toLowerCase().includes(term)) ||
        (item?.company_id?.toLowerCase().includes(term))
      ));

      setAllUnits(equipamentsSearch);
    }
  };

  // Auto-apply filter when data or search changes
  useEffect(() => {
    handleSearch();
  }, [filterUnits, searchData]);

  const handleSearchData = (e) => {
    setSearchData(e.target.value)
  };

  return (
    <Page className="p-3" title="Suporte OrangePi">
      <Header page={"Suporte OrangePi"} />

      {loading && <Reload />}

      <SearchBar
        onSearch={handleSearch}
        onSearchData={handleSearchData}
        searchData={searchData}
      />

      {allUnits && (
        <Results
          data={allUnits}
          permission={permission}
          currentTheme={currentTheme}
        />
      )}
    </Page >
  );
}

export default SuporteOrange;
